"use strict";

require("core-js/features/array/find");

require("core-js/es/math/trunc");

var _ci = _interopRequireDefault(require("./ci.service"));

require("./ci.styles.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.CIResponsive = _ci.default;